import { BrowserRouter, Routes, } from "react-router-dom"
import './App.css';
import Routess from "./Routes";
import { AppProvider } from "./Context/Context";



function App() {
  return (
    <>
    <AppProvider>
    <div className="App">
     <BrowserRouter>
      <Routess />
     </BrowserRouter>
    
    </div>
    </AppProvider>
    </>
  );
}

export default App;
